export default __webpack_public_path__ + "static/media/fileactivity.3f8c9013.svg";